import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Callout, ConfirmationModal, Typography } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { helpArticles } from '~/utils/helpArticles';
import ExternalLinkButton from '../ExternalLinkButton';
import styles from './ConfirmExternallySignModal.module.scss';
export default function ConfirmExternallySignModal(props) {
    const { bulkData, hasBilledImmediatelyService, dismissModal } = props;
    const hasMultipleClients = !!bulkData && bulkData.numClients > 1;
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: texts } = useLocaleKeys('components.confirmExternallySignModal');
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: bulkData ? texts.titleBulk() : texts.titleSingle(),
        textAlignCenter: false,
        width: "750px",
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.confirmExternallySigned,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: hasMultipleClients ? texts.warrantyBulk({
                        numClients: bulkData.numClients.toString()
                    }) : texts.warrantySingle()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.noteFollowing()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    as: "ul",
                    children: [
                        texts.noDigitalSignature(),
                        texts.invoicesIssued(),
                        texts.clientNotNotified()
                    ].map((text, idx)=>/*#__PURE__*/ _jsxs("li", {
                            className: styles.bullet,
                            children: [
                                /*#__PURE__*/ _jsx("span", {}),
                                text
                            ]
                        }, idx))
                }),
                /*#__PURE__*/ _jsxs(Callout, {
                    children: [
                        /*#__PURE__*/ _jsx(ExternalLinkButton, {
                            openInNewTab: true,
                            href: helpArticles.onboardingExistingClients(),
                            children: commonTexts.buttons.learnMore()
                        }),
                        ' ',
                        texts.learnMoreCallout()
                    ]
                }),
                hasBilledImmediatelyService && /*#__PURE__*/ _jsx(Callout, {
                    intent: "warning",
                    testId: "immediately-issued-warning",
                    children: texts.immediateInvoiceWarning()
                })
            ]
        }),
        primaryButtonLabel: hasMultipleClients ? texts.approveOnBehalfBulk() : texts.approveOnBehalfSingle(),
        primaryButtonTestId: "confirm-externally-sign",
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        secondaryButtonTestId: "cancel-externally-sign",
        onPrimaryButtonClick: ()=>dismissModal(true),
        onSecondaryButtonClick: ()=>dismissModal(false)
    });
}
